import BrowserStorage from './BrowserStorage';

export default new BrowserStorage(window?.sessionStorage);
